/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable default-param-last */
/* eslint-disable camelcase */
import { produce } from 'immer';

import MAINTENANCE_ACTION_TYPES from 'actionTypes/maintenance';
import { Custodian, CustodianName, MaintenanceState } from 'types/Maintenance';

const initialState: MaintenanceState = {
  neokredUpi: null,
  neokredImps: null,
  indianBankNeft: null,
};

const maintenanceReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case MAINTENANCE_ACTION_TYPES.FETCH_FIAT_DEPOSIT_ASSETS.SUCCESS: {
      const custodians = action.result.result || [];
      custodians.forEach((custodian: Custodian) => {
        const { fiat_deposit_custodian, maintenance_config } = custodian;
        if (fiat_deposit_custodian.toLowerCase() === CustodianName.NEOKRED) {
          draft.neokredUpi = maintenance_config.UPI ?? null;
          draft.neokredImps = maintenance_config.IMPS ?? null;
        } else if (fiat_deposit_custodian.toLowerCase() === CustodianName.INDIAN_BANK) {
          draft.indianBankNeft = maintenance_config.NEFT ?? null;
        }
      });
      break;
    }
    default:
      return draft;
  }
});

export default maintenanceReducer;
